<template>
  <div id="LandingEnerfip">
    <Hero>
      <h1>
        {{ $t('title') }}
      </h1>
    </Hero>

    <PublicBondIssue />
    <!-- <OtherDocuments /> -->
    <InvestmentDetails />
    <HowToInvest />
  </div>
</template>

<script>
import Hero from 'views/components/Hero'
import HowToInvest from './HowToInvest'
import InvestmentDetails from './InvestmentDetails'
import Meta from 'views/mixins/Meta'
// import OtherDocuments from './OtherDocuments'
import PublicBondIssue from './PublicBondIssue'
import { getters } from '../../utils'

export default {
  mixins: [
    Meta(require('@/assets/social/news.jpg')),
  ],
  components: {
    Hero,
    PublicBondIssue,
    HowToInvest,
    InvestmentDetails,
    // OtherDocuments,
  },
  computed: {
    ...getters(),
  },
}
</script>

<style lang="scss">
#LandingEnerfip {
  > .Hero {
    background-image: url('../../../assets/ellipses.png');
    background-position: right;
    background-size: cover;
    min-height: 70vh;
    text-align: center;

    h1 {
      margin-bottom: 4rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": "SIG and Enerfip Unveil Crowdfunding Campaign"
    },
    "title": "SIG and Enerfip Unveil Crowdfunding Campaign"
  },
  "es": {
    "meta": {
      "title": "Sig y Enerfip lanzan una campaña de Crowdfunding"
    },
    "title": "Sig y Enerfip lanzan una campaña de Crowdfunding"
  }
}
</i18n>
